import { css } from '@emotion/core';

const styles = {
  img: css`
    max-height: 48px;
    max-width: 100%;
  `,
  container: css`
    // fix the height of the containter to match the image.
    // The spinner is shorter than the image, so without this, there is a
    // visible re-layout when switching between image and spinner.
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  button: css`
    height: 48px;
    display: flex;
    background: none;
    border: none;
    align-items: center;
    justify-content: center;
  `,
};

export default styles;
